export default {
  // Header
  'header.temple.name': 'Cheonchuk Seonwon',
  'header.temple.english': 'Korean Buddhist Temple',
  'header.menu.introduction': 'About',
  'header.menu.greeting': 'Greeting',
  'header.menu.history': 'History',
  'header.menu.meaning': 'Significance',
  'header.menu.location': 'Location',
  'header.menu.practice': 'Practice',
  'header.menu.pilgrimage': 'Pilgrimage',
  'header.menu.news': 'News',
  'header.menu.resources': 'Resources',
  'header.menu.support': 'Support',

  // Hero Section
  'hero.title': 'Welcome to Cheonchuk Seonwon',
  'hero.subtitle': 'At the Sacred Site Where Buddha\'s Teachings Began, Jetavana, India',
  'hero.description': 'Cheonchuk Seonwon is a Korean Buddhist practice center located in Rajgir, Bihar, India. We walk the path of meditation and practice at the sacred site where Buddha first taught after attaining enlightenment.',
  'hero.button.visit': 'Visit Info',
  'hero.button.learn': 'Learn More',

  // Daily Wisdom
  'wisdom.title': 'Daily Dhammapada',
  'wisdom.original': '若以色見我 以音聲求我 是人行邪道 不能見如來',
  'wisdom.korean': '만약 나를 색(형상)으로 보려 하거나, 음성으로 찾으려 한다면, 그 사람은 삿된 길을 가고 있는 것이다. 그는 결코 여래를 볼 수 없다.',
  'wisdom.english': 'If you\'re trying to see me in colour, or in voice, he\'s on a dead path; he can never see the Buddha.',

  // Quick Links
  'links.title': 'Quick Guide',
  'links.visit.title': 'Visit Hours',
  'links.visit.morning': 'Morning Prayer',
  'links.visit.morning.time': '04:00-06:00',
  'links.visit.evening': 'Evening Prayer',
  'links.visit.evening.time': '18:00-19:00',
  'links.visit.lunch': 'Lunch Break',
  'links.visit.lunch.time': '12:00-13:00',
  'links.visit.contact': 'Contact Before Visit',
  'links.visit.phone': '+91-892-313-9035',
  'links.visit.manager': '(Manager Wardan)',
  'links.practice.title': 'Practice Programs',
  'links.practice.meditation': 'Meditation',
  'links.practice.dharma': 'Dharma Talk',
  'links.practice.retreat': 'Temple Stay',
  'links.support.title': 'Support',
  'links.support.regular': 'Regular Donation',
  'links.support.onetime': 'One-time Donation',
  'links.support.volunteer': 'Volunteer',

  // News Section
  'news.title': 'Temple News',
  'news.view': 'View Details',
  'news.date': 'Date',

  // Footer
  'footer.about.title': 'About Cheonchuk Seonwon',
  'footer.about.description': 'Cheonchuk Seonwon is a Korean Buddhist practice center located in Rajgir, India, the sacred site of Buddha.',
  'footer.contact.title': 'Contact',
  'footer.contact.address': 'Rajgir, Bihar, India',
  'footer.contact.phone': 'Phone',
  'footer.contact.email': 'Email',
  'footer.links.title': 'Quick Links',
  'footer.links.introduction': 'About',
  'footer.links.practice': 'Practice',
  'footer.links.pilgrimage': 'Pilgrimage',
  'footer.links.support': 'Support',
  'footer.hours.title': 'Visit Hours',
  'footer.hours.morning': 'Morning: 04:00-06:00',
  'footer.hours.evening': 'Evening: 18:00-19:00',
  'footer.hours.lunch': 'Lunch: 12:00-13:00',
  'footer.copyright': '© 2024 Cheonchuk Seonwon. All rights reserved.',
  'footer.powered': 'Website Builder',
};
